import { render } from "./CampaignForm.vue?vue&type=template&id=292c0859&scoped=true"
import script from "./CampaignForm.vue?vue&type=script&lang=js"
export * from "./CampaignForm.vue?vue&type=script&lang=js"

import "./CampaignForm.vue?vue&type=style&index=0&id=292c0859&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292c0859"]])

export default __exports__